var map = {
	"./angbao-bonus-thaipusam.webp": 2492,
	"./angbao-bonus.webp": 2493,
	"./angbao-bonus_dewali.webp": 2494,
	"./cny-lucky-draw.webp": 2495,
	"./cny-promo.webp": 2496,
	"./dewali-promo.webp": 2497,
	"./fifa-logo.webp": 2498,
	"./fifa-prediction.webp": 2499,
	"./fifa-qna.webp": 2500,
	"./raya-promo.webp": 2501,
	"./welcome-cny-bonus.webp": 2502
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2491;